









import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import MessageListTop from './MessageListTop.vue';
import MessageListBottom from './MessageListBottom.vue';
import { GetTaskMessagesSearchRequest, TaskMessageType, TaskMessageStatusType } from 'ncp-api-supporter';
import { taskMessagesGridDataInit, formDataInit } from './MessageListValues';
import { DEFAULT_TIME_RANGE } from '@/pro/components/common/datepicker/dateRange';

@Component({
  components: {
    PageTitle,
    PeriodDateCalendar,
    ItemTable,
    MessageListTop,
    MessageListBottom
  }
})
export default class MessageList extends Vue {
  private request = formDataInit;
  private taskMessages = taskMessagesGridDataInit;
  private totalCount = 0;


  private changeFormData(formData: GetTaskMessagesSearchRequest['params']) {
    this.request = { ...formData };

    this.setRequest(this.request);
  }

  private changePerPage({ page, size }) {
    this.request.page = page;
    this.request.size = size;

    this.setRequest(this.request);
  }

  private setRequest(request: GetTaskMessagesSearchRequest['params']) {
    const copyRequest = { ...request };

    if (!copyRequest.taskMessageTypes) {
      alert(this.$t('CLAIM_MESSAGE_SELECT_MESSAGE_TYPE'));

      return;
    }

    if (copyRequest.taskMessageTypes === 'ALL' as TaskMessageType) {
      delete copyRequest.taskMessageTypes;
    }

    if (copyRequest.taskMessageStatusType === 'ALL' as TaskMessageStatusType) {
      delete copyRequest.taskMessageStatusType;
    }

    this.getTaskMessage(copyRequest);
  }


  private async getTaskMessage(params: GetTaskMessagesSearchRequest['params']){
    const { data: { totalCount, items } } = await this.$api.getTaskMessagesSearch({ params: {
        ...params,
        startDateTime: `${params.startDateTime} ${DEFAULT_TIME_RANGE.START}`,
        endDateTime: `${params.endDateTime} ${DEFAULT_TIME_RANGE.END}`,
      } 
    });

    this.totalCount = totalCount;
    this.taskMessages = items.map((item) => ({
      mallName: item.mallName,
      orderNo: item.orderNo,
      taskMessageStatusType: item.taskMessageStatusType,
      updateYmdt: item.updateYmdt,
      taskMessageType: item.taskMessageType,
      content: item.content,
      registerAdminName: item.registerInfo.registerAdminName,
      completedAdminName: item.completedInfo?.completedAdminName ?? '',
    }))
  }

  created() {
    const statusType = this.$route.query.from === 'taskMessage' ? 'PROCESSING' : 'ALL' as TaskMessageStatusType;
    this.request.taskMessageStatusType = statusType;
  }
}
